import { get, cloneDeep, set } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import GetRecords from '../../../../../../../lib/api/GetRecords';
import { APIS } from '../../../../../../../lib/constants/apis';
import {
	removeNullDeep,
	removeDataKeys,
	getKostenKategorieArt,
	getOptionsFromRes,
	addIndexesToPath,
} from '../../../../../../../utils/helper';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import MUIAccordionComponent from '../../../../../../../components/ui-component/mui-accordion/MUIAccordionComponent';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import { getFormStrucComponentTable } from '../../../../../../../utils/formStruc';
import { concat } from 'lodash';

import Schema from '../../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const P = Schema.attributes;

const SonstigeKostenVN: FC<{ kostentraeger: string; unternehmenId?: number }> = ({ kostentraeger, unternehmenId }) => {
	const { application, setApplicationProperty, saveApplication, readOnly } = useApplication();
	const [kostenKategorie, setKostenKategorie] = useState([]);

	const handleAddSonstigesKostenVN = () => {
		try {
			let appCopy = cloneDeep(application);
			const data = {
				Kostentraeger: kostentraeger,
				Organisation: { id: unternehmenId },
				Ausgabenkategorie: kostenKategorie[0],
				Ausgaben_Ausgaben_Block_1: [{ Zelle_1: '' }],
			};
			set(appCopy, `${P.Ausgaben.path}.${get(application, P.Ausgaben.path, []).length}`, data);
			saveApplication(false, appCopy);
		} catch (err: any) {
			console.error('ERROR: Adding Sonstige Kosten ', err);
		}
	};

	const handleDeleteSonstigesKostenVN = async (index: number) => {
		try {
			let appCopy = cloneDeep(application);
			const allKostenPosition = get(appCopy, P.Ausgaben.path, []);
			set(
				appCopy,
				P.Ausgaben.path,
				allKostenPosition.filter((_: any, i: number) => i !== index),
			);
			saveApplication(false, appCopy);
		} catch (err: any) {
			console.error('ERROR: Deleting Sonstige Kosten ', err);
		}
	};

	useEffect(() => {
		const fetch = async () => {
			try {
				const filter = {
					Allgemein_Kostenposition: 'Ausgabe',
					Allgemein_Kostenart_Finanzierung: 'SonstigeKosten',
					Allgemein_Foerderprogramm: {
						$contains: get(application, P.Zuwendungsantrag.schema.attributes.Foerderprogramm.path + '.id'),
					},
				};
				let res = await GetRecords(APIS.KostenKategories, [], filter);

				setKostenKategorie(removeNullDeep(removeDataKeys(get(res, 'data', []))));
			} catch (err: any) {
				console.error('ERROR: Fetching Kostenkategories', err);
			}
		};
		fetch();
	}, []);

	return (
		<>
			{get(application, P.Ausgaben.path, []).map((ele: any, i: number) => {
				if (
					get(ele, 'Organisation.id') === unternehmenId &&
					get(ele, 'Kostentraeger') === kostentraeger &&
					getKostenKategorieArt(get(ele, 'Ausgabenkategorie'), kostenKategorie) === 'SonstigeKosten'
				) {
					return (
						<MUIAccordionComponent
							key={i}
							summaryTitle="Sonstige Kosten"
							onDelete={() => handleDeleteSonstigesKostenVN(i)}
							showDeleteButton={!readOnly}
						>
							<Grid2 container spacing={6}>
								<Grid2 sm={6}>
									<CreateForm
										formStruc={mapSonstigesKostenVN(strucSonstigesKostenVN(kostenKategorie), i)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={readOnly}
									/>
								</Grid2>
							</Grid2>
							<CreateForm
								formStruc={mapSonstigesKostenVN(formStrucErlaeuterungTable(application, i), i)}
								formValues={application}
								updateFormValuesFunc={setApplicationProperty}
								readOnly={readOnly}
							/>
						</MUIAccordionComponent>
					);
				}
			})}

			<Button sx={{ mt: '2rem' }} endIcon={<AddIcon />} onClick={handleAddSonstigesKostenVN} disabled={readOnly}>
				Sonstige Kosten hinzufügen
			</Button>
		</>
	);
};
export default SonstigeKostenVN;

const mapSonstigesKostenVN = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, P.Ausgaben.path.length) +
						`.${index}` +
						pathWithoutIndex.slice(P.Ausgaben.path.length),
				};
			}),
		};
	});
	return result;
};

const strucSonstigesKostenVN = (kostenKategorie: any) => {
	return [
		{
			fields: [
				{
					...P.Ausgaben.schema.attributes.Ausgabenkategorie,
					type: 'enumeration',
					options: getOptionsFromRes(kostenKategorie, 'Allgemein_Bezeichnung'),
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
};

const formStrucErlaeuterungTable = (application: any, i: number) => {
	return [
		{
			fields: [
				{
					...P.Ausgaben.schema.attributes.Ausgaben_Ausgaben_Block_1,
					type: 'componentTable',
					hideColumns: [
						'Zelle_4',
						...(get(application, P.Verwendungsnachweisstatus_Status.path) === 'inBearbeitung'
							? ['Zelle_3', 'Zelle_5']
							: []),
					],
					disabledColumns: ['Zelle_4', 'Zelle_3', 'Zelle_5'],
					fieldProps: { Zelle_2: { format: 'currency', label: 'Verausgabt (€)' }, Zelle_3: { format: 'currency' } },
					sumRow: [
						{
							id: 'pinnedRow',
							Zelle_1: 'Zwischensumme',
							Zelle_2: get(
								application,
								addIndexesToPath(P.Ausgaben.schema.attributes.Zelle_2.path, [`${i}`], ['Ausgaben']),
							),
							Zelle_3: get(
								application,
								addIndexesToPath(P.Ausgaben.schema.attributes.Zelle_3.path, [`${i}`], ['Ausgaben']),
							),
						},
					],
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
};

export const GetVNSonstigesKostenFormStruc = (
	application: any,
	unternehmenId: number,
	kostentraeger: string,
	kostenKategorie: any,
) => {
	let formStruc: FormStrucItem[] = [];
	get(application, P.Ausgaben.path, []).forEach((ele: any, i: number) => {
		if (
			get(ele, 'Organisation.id') === unternehmenId &&
			get(ele, 'Kostentraeger') === kostentraeger &&
			getKostenKategorieArt(get(ele, 'Ausgabenkategorie'), kostenKategorie) === 'SonstigeKosten'
		) {
			const formStrucCT2WithIndex = getFormStrucComponentTable(
				application,
				mapSonstigesKostenVN(formStrucErlaeuterungTable(application, i), i),
			);
			const formStruc1WithIndex = mapSonstigesKostenVN(strucSonstigesKostenVN([]), i);
			formStruc = concat(formStruc, formStruc1WithIndex, formStrucCT2WithIndex);
		}
	});
	return formStruc;
};
